import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button } from 'ui-components/Button'

export const revert = css`
  transform: rotate(180deg);
`

export const current = css`
  font-weight: bold;
  opacity: 1;
`

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const Item = styled.li`
  display: inline;
`

export const ArrowButton = styled(Button)`
  font-size: 12px;
  margin-top: -4px;
  opacity: .4;
  display: inline-flex;

  &:hover {
    opacity: .8;
  }

  svg {
    height: 16px;
  }
`

export const PageButton = styled(Button)`
  font-size: 14px;
  opacity: .4;
  display: inline-flex;

  &:hover {
    opacity: .8;
  }
`

export const Info = styled.div`
  font-size: 12px;
  opacity: .4;
  padding: 0 5px;
  line-height: 16px;
`
